export const LoiTermFormFieldKeys = {
    loiExpirationDate: 'loiExpirationDate',
    exclusivityPeriodDays: 'exclusivityPeriodDays',

    practicePropertyPurchased: 'practicePropertyPurchased',

    cashAtClose: 'cashAtClose',
    workingCapitalHoldback: 'workingCapitalHoldback',
    netCashAtClose: 'netCashAtClose',
    earnout: 'earnout',
    syntheticJvEquity: 'syntheticJvEquity',
    deferredFixedPaymentsTotal: 'deferredFixedPaymentsTotal',
    jvEquityTotal: 'jvEquityTotal',
    corporateEquityPreferred: 'corporateEquityPreferred',
    corporateEquityCommon: 'corporateEquityCommon',
    other: 'other',
    totalPurchasePrice: 'totalPurchasePrice',

    obligorName: 'obligorName',
    seniorDebt: 'seniorDebt',
    allOtherLiabilities: 'allOtherLiabilities',
    balanceSheetCash: 'balanceSheetCash',
    ltmEbitdaProForma: 'ltmEbitdaProForma',
    generalDeferredPaymentsInformation: 'generalDeferredPaymentsInformation',
} as const;

export const GeneralDeferredPaymentsFieldKeys: string[] = [
    LoiTermFormFieldKeys.obligorName,
    LoiTermFormFieldKeys.seniorDebt,
    LoiTermFormFieldKeys.allOtherLiabilities,
    LoiTermFormFieldKeys.balanceSheetCash,
    LoiTermFormFieldKeys.ltmEbitdaProForma,
];

export const LoiTermFormRowFieldKey = {
    dfpRow: (index: number) => `dfp:${index}`,
    dvpRow: (index: number) => `dvp:${index}`,
    jvEquityRow: (index: number) => `jvEquity:${index}`,
    corporateEquityRow: (type: 'Preferred' | 'Common', index: number) => `corporateEquity:${type}:${index}`,
    leaseRow: (locationId: string) => `lease:${locationId}`,
    sellerCovenantRow: (locationId: string) => `sellerCovenant:${locationId}`,
    ncrRow: (index: number) => `ncr:${index}`,
    nsrRow: (index: number) => `nsr:${index}`,
    amcRow: (index: number) => `amc:${index}`,
};
